import { fleetCloudProviderSchema } from './fleet-cloud-provider.schema';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';
import {
  companyTypeOptions,
  companyTypeSchema,
} from '../../../schemas/company-type.schema';
import { z } from 'zod/v4';

export const fleetOnlyAccountSchema = z.object({
  accountId: z.number(),
  accountName: z.string(),
  accountType: createEnumSchemaPreprocessor(
    companyTypeSchema.nullable(),
    companyTypeOptions
  ),
  cloudProvider: fleetCloudProviderSchema,
});

export type FleetOnlyAccount = z.infer<typeof fleetOnlyAccountSchema>;
